export default "__VITE_ASSET__C9Z7TA9Q__"